import { k } from '../../localization/t';

// Profile trophies. The server returns one entry per honour a player
// holds ({ kind, seasonId, rank, earnedAt, points, wins, losses, ... }).
// The only kind so far is 'ranked-season', a podium finish in a ranked
// season. Tournament trophies will arrive as further kinds.

// Medal gradients by podium rank: [highlight, body, shadow]. Shared with
// the Hall of Fame so a champion's medal looks the same on both surfaces.
export const MEDAL_COLORS = {
  1: ['#fff2bf', '#f0c84a', '#7d5a16'],
  2: ['#f6f6f6', '#cfcfcf', '#7a7a7a'],
  3: ['#f0c08a', '#c3854a', '#5e3614'],
};

const RANK_LABELS = { 1: k('Champion'), 2: k('Runner-Up'), 3: k('Third Place') };

export function trophyRankLabel(rank) {
  return RANK_LABELS[rank] || `Top ${rank}`;
}

// "Season 12" for a ranked-season trophy.
export function trophyTitle(trophy) {
  if (trophy.kind === 'ranked-season') return `Season ${trophy.seasonId}`;
  return trophy.kind;
}

// "+123 valor · 14W 6L", or null when the snapshot carried no record.
export function trophyRecord(trophy) {
  if (typeof trophy.points !== 'number') return null;
  const points = trophy.points > 0 ? `+${trophy.points}` : String(trophy.points);
  return `${points} valor · ${trophy.wins}W ${trophy.losses}L`;
}

// Metal palettes for the prize badge, by podium rank. `hi` through
// `deep` are the brushed-metal ramp; `enamel*` the dark field the
// ornament sits on; `glow` the halo the badge casts on its surface.
export const TROPHY_METALS = {
  1: {
    name: k('gold'),
    hi: '#fff6d2', light: '#f6d98a', mid: '#d8ad4a', dark: '#8f6418', deep: '#4b3109',
    enamelLight: '#6a2612', enamelDark: '#1c0906',
    glow: 'rgba(246, 204, 96, 0.55)',
  },
  2: {
    name: k('silver'),
    hi: '#ffffff', light: '#eef1f5', mid: '#bcc4ce', dark: '#6f7987', deep: '#343a44',
    enamelLight: '#25313f', enamelDark: '#0a0e14',
    glow: 'rgba(205, 216, 232, 0.45)',
  },
  3: {
    name: k('bronze'),
    hi: '#ffe6cc', light: '#eaae78', mid: '#bd7540', dark: '#71401a', deep: '#331808',
    enamelLight: '#3a1c0e', enamelDark: '#110705',
    glow: 'rgba(226, 146, 84, 0.45)',
  },
};

export const ROMAN_RANKS = { 1: 'I', 2: 'II', 3: 'III' };
